module.exports = __webpack_public_path__ + "static/media/call_icon.7967e301.svg";